import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoggedInGuard } from './auth/logged-in.guard';

import { LoginComponent } from './auth/login.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: 'login', component: LoginComponent },
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {
        path: '',
        loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./home/home.module')['HomeModule']);  });}),
        canActivate: [LoggedInGuard]
      }
    ])
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/app-routing.module.ts
 **/